import React from "react";

const BandcampIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    className="bi bi-bandcamp"
    viewBox="0 0 24 24"
  >
    <title>Bandcamp</title>
    <path d="M0 18.75l7.437-13.5H24l-7.438 13.5H0z" />
  </svg>
);

export default BandcampIcon;
